"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageType;
(function (PageType) {
    /**
     * 打开一个 web 地址
     */
    PageType["Web"] = "web";
    /**
     * 商品详情页
     */
    PageType["ProductDetail"] = "productDetail";
    /**
     * 充值页
     */
    PageType["TopUp"] = "topup";
    /**
     * 登录
     */
    PageType["Login"] = "login";
    /**
     * 关闭
     */
    PageType["Close"] = "close";
    /**
     * 首页
     */
    PageType["Home"] = "shopHome";
    /**
     * Prime 会员首页
     */
    PageType["PrimeHome"] = "primeHome";
    /**
     * Toast
     */
    PageType["Toast"] = "toast";
    /**
     * 调用分享功能
     */
    PageType["Share"] = "share";
    /**
     * 拼团大团详情页
     */
    PageType["FriendsDealEvent"] = "friendsdeal/event";
    /**
     * 拼团小团详情
     */
    PageType["FriendsDealGroup"] = "friendsdeal/group";
    /**
     * livechat
     */
    PageType["LiveChat"] = "livechat";
    /**
     * aftersale
     */
    PageType["AfterSale"] = "aftersale";
    /**
     * 支付结果页
     */
    PageType["Tokenization"] = "tokenization";
    /**
     * 请求获取通知权限
     */
    PageType["Notification"] = "notification";
    /**
     * 日历提醒
     */
    PageType["Reminder"] = "reminder";
    /**
     * 类目页
     */
    PageType["Category"] = "category";
    /**
     * 搜索结果页
     */
    PageType["Search"] = "search";
    /**
     * 促销商品列表页
     */
    PageType["Promotion"] = "promotion";
    /**
     * 店铺页
     */
    PageType["Shop"] = "ezseller";
    /**
     * Surf 页
     */
    PageType["Surf"] = "surf";
    /**
     * App引流注册页面
     */
    PageType["Register"] = "register";
    PageType["ToCompleted"] = "toCompleted";
    PageType["Unpaid"] = "unpaid";
    PageType["Copy"] = "copy";
    PageType["NavItemsEvent"] = "navItemsEvent";
    PageType["Mine"] = "mine";
})(PageType = exports.PageType || (exports.PageType = {}));
